import { Crafting__factory } from 'public/abi/evm/types';
import useProvider from '~/composables/useProvider';
import type { BuildingProps, RecipeProps } from '~/types/crafting';
import { BigNumber } from 'bignumber.js';
import { useWeb3ModalAccount } from '@web3modal/ethers/vue';

export default () => {
  const store = useMainStore();
  const { availableTokens } = useTokensReader();
  const { address } = useWeb3ModalAccount();
  const { blockchain } = useEnvs();
  const { getProvider } = useProvider();
  // const { data: runningRecipes } = useNuxtData('recipes/in-queue');
  const { data: recipeToCraft } = useNuxtData<RecipeProps>('recipes/recipe');
  const building = inject<Ref<BuildingProps>>('building');

  const maxAmountAvailableForCraft = ref(0);
  const isEnoughTokens = ref(false);
  const isLoading = ref(false);

  watch(
    [address, recipeToCraft, () => store.notificationUpdateVersion],
    async () => {
      try {
        isLoading.value = true;

        const contract = Crafting__factory.connect(blockchain.contracts.crafting, getProvider());

        let maxQueue = 0;

        try {
          maxQueue = parseInt(
            (
              await contract.getMaxQueueForUserInBuilding(
                String(address.value),
                building?.value.buildingHash || '',
                recipeToCraft.value?.recipeId || ''
              )
            ).toString()
          );
        } catch (error) {
          maxQueue = 0;
        }

        const balanceAbilityToProduce: Promise<number>[] | undefined = recipeToCraft.value?.ingredients.map(
          async (ingredient) => {
            const ingredientBalance = !address.value
              ? 0
              : await availableTokens(address.value, ingredient.tokenAddress);

            return new BigNumber(ingredientBalance).dividedBy(new BigNumber(ingredient.quantity)).toNumber();
          }
        );

        const promises: number[] = balanceAbilityToProduce ? await Promise.all(balanceAbilityToProduce) : [];

        if (promises.some((tokenProduceAbility) => tokenProduceAbility < 1)) {
          isEnoughTokens.value = false;
        } else {
          isEnoughTokens.value = true;
        }

        const minRecipesCount = Math.floor(Math.min(...promises));

        const maxQueueNumber = BigNumber(maxQueue).toNumber();
        maxAmountAvailableForCraft.value = minRecipesCount >= maxQueueNumber ? maxQueueNumber : minRecipesCount;
      } catch (error) {
        console.error(error, 'error on getting maxAmountAvailableForCraft');
      } finally {
        isLoading.value = false;
      }
    },
    {
      immediate: true
    }
  );

  return { maxAmountAvailableForCraft, isLoading, isEnoughTokens };
};
